import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

getVersion().then((version) => {
  console.log(`Version: ${version}`);

  console.log(environment.name);

  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch((err) => {
      console.error(err);
    });
});

async function getVersion() {
  try {
    let response = await fetch('/assets/version.json', {
      method: 'get',
    });

    if (response.ok) {
      let version = await response.json();
      return version.version;
    } else return '0.0.0';
  } catch (err) {
    return '0.0.0';
  }
}
